// src/components/Services/Services_SoftwareDevelopment.jsx
import React from 'react';
import { motion } from 'framer-motion';
import developmentGif from '../images/photos/development.gif'; // ✅ New GIF

const pageVariants = {
  initial: { rotateY: 90, opacity: 0 },
  in: { rotateY: 0, opacity: 1 },
  out: { rotateY: -90, opacity: 0 },
};

const pageTransition = { type: 'spring', stiffness: 80, damping: 20 };

const fadeUp = {
  hidden: { y: 10, opacity: 0 },
  visible: (i = 0) => ({ y: 0, opacity: 1, transition: { delay: 0.06 * i } }),
};

export default function Services_SoftwareDevelopment() {
  const services = [
    'Android Zero Touch Enrollment',
    'Android Management',
    'Cloud Computing',
    'Cloud Management Service',
    'Cyber Security',
    'iOS Management',
    'Mobile Management',
    'IT Management',
    'IT Support',
    'Software Development',
    'Digital Marketing',
  ];

  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
      style={{ minHeight: '100vh', background: '#040d1fff', color: '#e5e9edff', padding: 32 }}
    >
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        {/* HERO SECTION */}
        <section className="hero">
          {/* LEFT - GIF */}
          <motion.div initial="hidden" animate="visible" variants={fadeUp} custom={0}>
            <img
              src={developmentGif}
              alt="Software Development Demo"
              style={{
                width: '100%',
                maxWidth: 500,
                height: 'auto',
                borderRadius: 12,
                boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
              }}
              loading="lazy"
            />
          </motion.div>

          {/* RIGHT - TEXT */}
          <motion.div initial="hidden" animate="visible" variants={fadeUp} custom={1}>
            <h1 style={{ marginTop: 0, fontSize: '2.5rem', color: '#6dd4e8ff' }}>
              Software Development
            </h1>
            <p style={{ lineHeight: 1.6, color: '#e2e8f0' }}>
              Zyntro provides end-to-end software development services tailored to your business needs.
            </p>

            <h3 style={{ marginTop: 16, color: '#53bdd2ff' }}>Our Software Development Services:</h3>
            <ul style={{ lineHeight: 1.7, color: '#f1f5f9' }}>
              <li><strong>Custom Software Solutions:</strong> Tailored software to match your business requirements.</li>
              <li><strong>Web & Mobile Applications:</strong> Full-stack development for seamless digital experiences.</li>
              <li><strong>Cloud-based Solutions:</strong> Scalable cloud apps and integrations.</li>
              <li><strong>API Development & Integration:</strong> Secure and efficient system connectivity.</li>
              <li><strong>Maintenance & Support:</strong> Continuous monitoring, updates, and troubleshooting.</li>
            </ul>

            <h3 style={{ marginTop: 16, color: '#53bdd2ff' }}>Why It Matters:</h3>
            <p style={{ lineHeight: 1.6, color: '#f1f5f9' }}>
              Software development drives innovation and efficiency for businesses. Properly developed applications enhance productivity, ensure security, and enable digital transformation.
            </p>

            {/* CTA Buttons */}
            <div style={{ marginTop: 18, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <a
                href="mailto:support@zyntro.in"
                style={{
                  background: '#f69f48ff',
                  color: 'white',
                  padding: '10px 16px',
                  borderRadius: 8,
                  textDecoration: 'none',
                  fontWeight: 600,
                }}
              >
                Email Support
              </a>
              <a
                href="tel:+919956353236"
                style={{
                  border: '1px solid #4e4e54ff',
                  color: '#010101ff',
                  padding: '10px 16px',
                  borderRadius: 8,
                  textDecoration: 'none',
                  fontWeight: 600,
                  background: 'white',
                }}
              >
                Call +91-9956353236
              </a>
            </div>
          </motion.div>
        </section>

        {/* OTHER SERVICES */}
        <section style={{ marginTop: 40 }}>
          <h3 style={{ color: '#4fe1f4ff' }}>Other Services</h3>
          <div className="services-grid">
            {services.map((s) => (
              <div key={s} className="service-card">
                <div className="icon">{s.charAt(0)}</div>
                <span>{s}</span>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Responsive CSS */}
      <style>{`
        .hero {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 32px;
          align-items: center;
        }
        .services-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 14px;
          margin-top: 16px;
        }
        .service-card {
          background: #1e293b;
          padding: 12px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          gap: 10px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.3);
        }
        .service-card .icon {
          width: 36px;
          height: 36px;
          border-radius: 8px;
          background: #1e7d95ff;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
        }
        .service-card span {
          font-size: 15px;
        }

        @media (max-width: 1024px) {
          .hero {
            grid-template-columns: 1fr;
            text-align: center;
          }
          .hero img {
            margin: 0 auto;
          }
          .hero ul {
            text-align: left;
          }
        }

        @media (max-width: 600px) {
          .services-grid {
            grid-template-columns: 1fr;
          }
          .service-card {
            justify-content: center;
            text-align: center;
          }
        }
      `}</style>
    </motion.div>
  );
}
